"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalNavIconBar = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const vertical_icon_bar_styles_1 = require("../vertical_icon_bar/vertical_icon_bar.styles");
const buttons_1 = require("../buttons");
const theme_1 = __importDefault(require("../../styles/theme"));
const VerticalNavIconBar = props => {
    const { expanded, toggleNavBar, children } = props;
    const navBarIconName = expanded ? 'CloseCaretIconOffCenter' : 'OpenCaretIconOffCenter';
    const showToggle = typeof toggleNavBar === 'function';
    return ((0, jsx_runtime_1.jsx)(vertical_icon_bar_styles_1.Wrapper, Object.assign({ expanded: expanded }, { children: (0, jsx_runtime_1.jsxs)(vertical_icon_bar_styles_1.VertNavButtonsWrapper, Object.assign({ "data-testid": props['data-testid'], expanded: expanded }, { children: [showToggle && ((0, jsx_runtime_1.jsx)(vertical_icon_bar_styles_1.NavBarToggle, Object.assign({ expanded: expanded }, { children: (0, jsx_runtime_1.jsx)(buttons_1.IconButton, { iconName: navBarIconName, onClick: toggleNavBar, label: "Toggle expanded side nav", style: {
                            width: '30px',
                            height: '30px',
                            background: theme_1.default.colors.blue80,
                        }, fill: "white" }) }))), children] })) })));
};
exports.VerticalNavIconBar = VerticalNavIconBar;
//# sourceMappingURL=vertical_nav_icon_bar.js.map